module.exports = __webpack_public_path__ + "static/images/traffic.3z1_qas.svg";